import { fetch } from "src/services/apollo-fetch";
import { Query } from "../_api";

export default {
    async fetchZipCodeRates(context, rateTableName) {
        const response = await fetch.query({
            query: Query.zipCodeRates,
            variables: { rateTableName },
        });
        return response.data.zipCodeRates;
    },
    async fetchRateTables() {
        const response = await fetch.query({
            query: Query.rateTables,
        });
        return response.data.rateTables;
    },
    async fetchDefaultRateTable() {
        const response = await fetch.query({
            query: Query.defaultRateTable,
        });
        return response.data.defaultRateTable;
    },
};
